import mapValues from 'lodash/mapValues'
import mapKeys from 'lodash/mapKeys'
import isPlainObject from 'lodash/isPlainObject'
import isArray from 'lodash/isArray'
import camelCase from 'lodash/camelCase'

export const convertSnakeCaseToCamelCase = (obj: any): any => {
  try {
    if (isArray(obj)) {
      return obj.map((value: any) => convertSnakeCaseToCamelCase(value))
    } else if (isPlainObject(obj)) {
      return mapKeys(
        mapValues(obj, (value: any) => convertSnakeCaseToCamelCase(value)),
        (_v: any, key: any) => camelCase(key)
      )
    }
    return obj
  } catch (error) {
    return obj
  }
}
// export const snakeToCamel = (
//   obj: { [key: string]: any },
//   seen = new WeakSet()
// ): any => {
//   if (obj instanceof ArrayBuffer) {
//     return obj // Devolver tal cual
//   }
//   if (obj && typeof obj === 'object') {
//     if (seen.has(obj)) {
//       return obj // Evita el ciclo
//     }
//     seen.add(obj)
//   }

//   if (Array.isArray(obj)) {
//     return obj.map((value) => convertSnakeCaseToCamelCase(value, seen))
//   } else if (
//     obj &&
//     typeof obj === 'object' &&
//     !(obj instanceof Date) &&
//     !(obj instanceof RegExp)
//   ) {
//     return Object.keys(obj).reduce((result: { [key: string]: any }, key) => {
//       const newKey = key.replace(/_([a-z])/g, (_, letter) =>
//         letter.toUpperCase()
//       )
//       const value = obj[key]
//       result[newKey] = convertSnakeCaseToCamelCase(value, seen)
//       return result
//     }, {})
//   }
//   return obj
// }

export const camelToSnake = (obj: Record<string, any>): Record<string, any> => {
  const snakeCaseObj: Record<string, any> = {}
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const snakeCaseKey = key?.replace(/[A-Z]/g, (match, offset) => {
        return (offset ? '_' : '') + match?.toLowerCase()
      })
      snakeCaseObj[snakeCaseKey] = obj?.[key]
    }
  }
  return snakeCaseObj
}
